/**
 * Opens the header details-modal search from drawer trigger buttons (data-drawer-search-open).
 * Keeps the menu drawer open; uses the existing details-modal instance in the header.
 */
(function () {
  function getSearchModal(header) {
    var primary = header.querySelector('#Search-In-Modal');
    var alt = header.querySelector('#Search-In-Modal-1');
    var input = primary || alt;
    if (input) {
      var modal = input.closest('details-modal');
      if (modal) return modal;
    }
    return header.querySelector('details-modal.header__search');
  }

  function openSearchFromDrawer(header) {
    var modal = getSearchModal(header);
    if (!modal || typeof modal.open !== 'function') return;
    var summary = modal.summaryToggle;
    if (!summary) return;
    if (modal.detailsContainer && modal.detailsContainer.hasAttribute('open')) return;
    modal.open({ target: summary });
  }

  /**
   * Defer opening so the same user click does not bubble to document.body after
   * details-modal.js registers its body listener — that listener would treat the
   * drawer click as an "outside" click and close the search immediately.
   */
  function queueOpenSearchFromDrawer(header) {
    var h = header;
    setTimeout(function () {
      openSearchFromDrawer(h);
    }, 0);
  }

  function bindHeader(header) {
    if (!header || header.getAttribute('data-drawer-search-bound') === '1') return;
    header.setAttribute('data-drawer-search-bound', '1');
    header.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-drawer-search-open]');
      if (!btn || !header.contains(btn)) return;
      e.preventDefault();
      queueOpenSearchFromDrawer(header);
    });
    header.addEventListener('keydown', function (e) {
      var btn = e.target.closest('[data-drawer-search-open]');
      if (!btn || !header.contains(btn)) return;
      var code = e.code.toUpperCase();
      if (code !== 'ENTER' && code !== 'SPACE') return;
      if (code === 'SPACE') e.preventDefault();
      queueOpenSearchFromDrawer(header);
    });
  }

  function initIn(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.header--drawer-search-mobile').forEach(bindHeader);
  }

  function onSectionLoad(event) {
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.header--drawer-search-mobile').forEach(function (h) {
      h.removeAttribute('data-drawer-search-bound');
      bindHeader(h);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initIn(document);
    });
  } else {
    initIn(document);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
})();
